<div class="deal-image-selector">
  <div
    *ngFor="let item of items"
    class="deal-image-selector__item"
    [class.deal-image-selector__item--selected]="item.selected"
    (click)="toggleItem(item)"
    role="checkbox"
    [attr.aria-checked]="item.selected"
    [attr.aria-label]="item.filename"
    tabindex="0"
    (keydown.space)="
      $event.preventDefault(); $event.stopPropagation(); toggleItem(item)
    "
    (keydown.enter)="
      $event.preventDefault(); $event.stopPropagation(); toggleItem(item)
    "
  >
    <img class="deal-image-selector__thumb" [src]="item.thumbnailUrl" alt="" />
    <div class="deal-image-selector__overlay">
      <div class="deal-image-selector__check">
        <img
          *ngIf="item.selected"
          src="assets/icons/gl_check.svg"
          alt=""
          width="14"
          height="14"
        />
      </div>
    </div>
  </div>
</div>
